'use client';
import React, { useState, useEffect } from 'react';
import { RefreshCw, Download, ChevronDown, Activity } from 'lucide-react';

export default function DashboardHeader() {
  const [lastUpdated, setLastUpdated] = useState('');
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    setLastUpdated('May 28, 2026 — 01:23 AM WAT');
  }, []);

  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => {
      setIsRefreshing(false);
      setLastUpdated('May 28, 2026 — 01:23 AM WAT');
    }, 1200);
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-5">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-1">
          <div
            className="w-2 h-2 rounded-full animate-pulse flex-shrink-0"
            style={{ backgroundColor: 'var(--accent)' }}
          />
          <span className="text-xs font-semibold uppercase tracking-widest" style={{ color: 'var(--accent)' }}>
            Live
          </span>
        </div>
        <h1 className="text-lg sm:text-xl font-bold leading-tight" style={{ color: 'var(--dark-text)' }}>
          Real Property Tax Revenue Intelligence Command
        </h1>
        <p className="text-xs sm:text-sm mt-0.5" style={{ color: 'var(--dark-muted)' }}>
          FY 2026 · Target: USD 1.176B · {lastUpdated && `Updated: ${lastUpdated}`}
        </p>
      </div>

      <div className="flex items-center gap-2 flex-wrap w-full sm:w-auto">
        {/* Date range selector */}
        <button
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-150 hover:bg-white/10"
          style={{
            backgroundColor: 'var(--dark-card)',
            color: 'var(--dark-text)',
            border: '1px solid var(--dark-border)',
          }}
        >
          <span>YTD 2026</span>
          <ChevronDown size={14} />
        </button>

        {/* Live indicator */}
        <div
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium"
          style={{
            backgroundColor: 'rgba(22, 101, 52, 0.2)',
            color: '#4ade80',
            border: '1px solid rgba(74, 222, 128, 0.2)',
          }}
        >
          <Activity size={14} />
          <span className="hidden xs:inline">ASYCUDA</span>
          <span className="xs:hidden">Live</span>
        </div>

        <button
          onClick={handleRefresh}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-150 hover:bg-white/10 active:scale-95"
          style={{
            backgroundColor: 'var(--dark-card)',
            color: 'var(--dark-text)',
            border: '1px solid var(--dark-border)',
          }}
        >
          <RefreshCw size={14} className={isRefreshing ? 'animate-spin' : ''} />
          <span className="hidden sm:inline">Refresh</span>
        </button>

        <button
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-150 hover:opacity-90 active:scale-95"
          style={{
            backgroundColor: 'var(--accent)',
            color: 'var(--accent-foreground)',
          }}
        >
          <Download size={14} />
          <span className="hidden sm:inline">Export Report</span>
        </button>
      </div>
    </div>
  );
}